/**
 * What a guest seat costs: the slot's per-person rate less the member tier's guest discount.
 * Mirrors the server's WalkInPricing (GuestDiscount): full - Math.Round(full * bp / 10000), where
 * .NET's Math.Round rounds a half to the even neighbour. The server's figure is what is charged;
 * this is the wizard's quote, and the two must agree to the cent.
 */
export function guestSeatPriceCents(listCents: number | undefined, discountBp: number): number | undefined {
  if (listCents === undefined) return undefined;
  if (!(discountBp > 0)) return listCents;
  return listCents - roundHalfToEven((listCents * discountBp) / 10000);
}

function roundHalfToEven(value: number): number {
  const floor = Math.floor(value);
  const diff = value - floor;
  if (diff > 0.5) return floor + 1;
  if (diff < 0.5) return floor;
  return floor % 2 === 0 ? floor : floor + 1;
}
